import ProjectOverview from './ProjectOverview';
import TechStack from './TechStack';

export default function ProjectContent({ project, isExpanded, onToggleExpanded }) {
  return (
    <div className="flex-1 flex flex-col min-h-0 relative">
      {/* Title */}
      <h3 className="text-emerald-200 font-semibold text-lg mb-3">
        {project.projectTitle}
      </h3>

      {/* Overview with expansion */}
      <ProjectOverview 
        overview={project.projectOverview}
        isExpanded={isExpanded}
        onToggleExpanded={onToggleExpanded}
      />

      {/* Tech stack at bottom */}
      <TechStack technologies={project.projectTech} />
    </div>
  );
}